<template>
  <div class="">
    <div class="w-full max-w-md">
      <WelcomeBanner />

      <TopAffiliates v-if="is_staff" @affiliate-selected="changeAffiliate" />
      <ModoHackConversion v-if="is_staff" @affiliate-selected="changeAffiliate" />
      <DropdownAffiliate v-if="is_staff" @affiliate-selected="changeAffiliate" />
      
      <AfiliadoBanner :affiliate_id="affiliate_id" />
      <DailyCards  :affiliate_id="affiliate_id" />
      <FtdChart  :affiliate_id="affiliate_id" />
      <DepositChart  :affiliate_id="affiliate_id" />
      <CommissionChart  :affiliate_id="affiliate_id" />
      <LastUsers  :affiliate_id="affiliate_id" />
      <CommissionsList  :affiliate_id="affiliate_id" />
    </div>
  </div>
</template>

  
  <script>
  import WelcomeBanner from '../components/WelcomeBanner.vue';
  import AfiliadoBanner from '../components/AfiliadoBanner.vue';
  import DailyCards from '../components/DailyCards.vue';
  import DepositChart from '../components/DepositChart.vue';
  import LastUsers from '../components/LastUsers.vue';
  import FtdChart from '../components/FtdChart.vue';
  import DropdownAffiliate from '../components/DropdownAffiliate.vue';
  import TopAffiliates from '../components/TopAffiliates.vue';
  import api from '@/services/api';
  import ModoHackConversion from '../components/ModoHackConversion.vue';
  // Comissoes: nunca entrou no git; reconstruido do source map da release Firebase de
  // 26/08/2025 (migracao-gcp-aws/codigo-extraido/x/live-socio-hypezbet), 17/09/2026.
  import CommissionChart from '../components/CommissionChart.vue';
  import CommissionsList from '../components/CommissionsList.vue';
  import { assinarWebPushSeAutorizado } from '@/services/webPush';
  import { relatarSeNaoAssinou } from '@/services/relatoDoPush';
  import { identificarAparelho } from '@/services/aparelho';
  import { renovarTokenDoPainel } from '@/services/tokenDoPainel';
  import { messaging, getToken } from '../firebaseConfig';
  // Chave VAPID do PROJETO Firebase (nao a nossa): e' o que o getToken exige.
  const CHAVE_FIREBASE = 'BBXU8VejhyacmsVb_eUe-iN9r-2LbBP5quvO8zH2kcJ9828VYsMGLVczvJgeEvW0LiZ3yV0Kleh9TpEG3hUpSrk';
  import { setCookie } from '@/services/cookie';

  export default {
    name: 'DashboardView',
    components: {
      WelcomeBanner,
      AfiliadoBanner,
      DailyCards,
      DepositChart,
      LastUsers,
      FtdChart,
      DropdownAffiliate,
      TopAffiliates,
      ModoHackConversion,
      CommissionChart,
      CommissionsList,
    },
    data() {
      return {
        affiliate_id: null,
        is_staff: false,
      };
    },
    created() {
      this.getUser();
      // F4, dual-run: o dashboard e' a tela que TODO socio logado abre; a de
      // push so quem clica no sino. Sem assinar aqui, os 297 aparelhos do
      // Socios nao migrariam para o VAPID antes do corte do FCM
      // (plano-firebase-para-aws.md secao 3, F4). Nao pede permissao nova.
      identificarAparelho().then((deviceId) => {
        // Carimba o aparelho no token FCM que este navegador ja registrou. O
        // dashboard e' a tela que todo socio abre; a do sino so quem clica. Sem
        // este carimbo o token fica sem dono conhecido, o corte cai para o nivel
        // do usuario e o SEGUNDO aparelho do operador fica mudo
        // (dashboard/push_deposito.py _tokens_nao_cobertos).
        // Pega o token ATUAL do Firebase em vez de reenviar o guardado. O valor
        // guardado some quando a pessoa limpa os dados (e ai nada era registrado,
        // em silencio) e fica velho quando o FCM rotaciona o token (e ai era
        // ressuscitado morto, piscando entre ativo e recusado). Ver
        // services/tokenDoPainel.js para por que chamar getToken aqui e' seguro.
        renovarTokenDoPainel({
          http: api, deviceId, messaging, getToken, chave: CHAVE_FIREBASE,
        }).then((token) => {
          if (token) setCookie('fcm-token', token, 300);
        });
        return assinarWebPushSeAutorizado(api, deviceId)
          .then((r) => relatarSeNaoAssinou(api, r));
      });
    },
    methods: {
      changeAffiliate(affiliate_id) {
        console.log('Affiliate Selected:', affiliate_id);
        this.affiliate_id = affiliate_id;
      },
      // dashboard/api/user/
      getUser() {
        // Implemente a lógica para obter o usuário logado
        api.get('/dashboard/api/user/')
          .then(response => {
            this.is_staff = response.data.is_staff;
            this.affiliate_id = response.data.affiliate_id;
          })
          .catch(error => {
            console.error('Erro ao obter o usuário logado:', error);
          });
      },
    },
  }
  </script>
  
  <style scoped>
  /* Adicione estilos adicionais aqui, se necessário */
  </style>
  